import { Routes, Route, Navigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Applications from "./pages/Applications";
import ResetPassword from "./pages/ResetPassword";
import { ROUTE } from "./routes";
import "./App.css";
import AuthenticatedRoute from "./pages/AuthenticatedRoute";
import NotFound from "./pages/NotFound";
import ServiceUnavailablePage from "./pages/Error500Page";
import Settings from "./pages/Settings";
import "react-toastify/dist/ReactToastify.css";
import "./customToastify.css";
import SettingsCompanyDetails from "./pages/Settings/SettingsCompanyDetails";
import SettingsUsers from "./pages/Settings/SettingsUsers";
import SettingsApplicationTypeView from "./pages/Settings/SettingsApplicationTypeView";
import SettingsApplicationTypeNew from "./pages/Settings/SettingsApplicationTypeNew";
import SettingsApplicationTypes from "./pages/Settings/SettingsApplicationTypes";
import SettingsBillingDetails from "./pages/Settings/SettingsBillingDetails";
import { Profile } from "./pages/Profile";
import { NewApplication } from "./pages/NewApplication";
import { ApplicationView } from "./pages/ApplicationView";
import AccountPending from "./pages/AccountPending";
import ResetPasswordConfirmation from "./pages/ResetPasswordConfirmation";
import { IndividualView } from "./pages/IndividualView";
import { ApplicationIndividuals } from "./pages/ApplicationIndividuals";
import { AddApplicationIndividual } from "./pages/ApplicationIndividuals/AddApplicationIndividual";
import Logout from "./pages/Logout";
import CacheBuster from "react-cache-buster";
import packageInfo from "../package.json";
import { Flex } from "./components/Flex";
import { Loader } from "./components/Loader";
import CreatePassword from "./pages/CreatePassword";
import SettingsDPO from "./pages/Settings/SettingsDPO";
import SettingsPEPSanctions from "./pages/Settings/SettingsPEP&Sanctions";
import { HelpSupport } from "./pages/HelpSupport";
import SettingsBranding from "./pages/Settings/SettingsBranding";
import SettingsSplashScreens from "./pages/Settings/SettingsSplashScreens";
import SettingsSOFRiskScoring from "./pages/Settings/SettingsSOFRiskScoring";
import Checks from "./pages/Checks";
import { AddCheckIndividual } from "./pages/ChecksIndividuals/AddCheckIndividual";
import { IndividualChecksView } from "./pages/IndividualChecksView";
import { RunChecks } from "./pages/ChecksIndividuals/RunChecks";
import { NewCheck } from "./pages/ChecksIndividuals/NewCheck";
import { AddAddress } from "./pages/ChecksIndividuals/AddAddress";
import SettingsAdditionalDocumentsRequests from "./pages/Settings/SettingsAdditionalDocumentsRequests";
import SettingsApplicationTypeNewChecks from "./pages/Settings/SettingsApplicationTypeNewChecks";
import SettingsApplicationTypeNewDocuments from "./pages/Settings/SettingsApplicationTypeNewDocuments";
import Monitoring from "./pages/Monitoring";
import { IndividualMonitoringView } from "./pages/IndividualMonitoringView";
import { NewIndividual } from "./pages/NewMonitoringRecord/NewIndividual";
import { NewMonitoring } from "./pages/NewMonitoringRecord/NewMonitoring";
import SettingsForms from "./pages/Settings/Forms/SettingsForms";
import SettingsNewForm from "./pages/Settings/Forms/SettingsNewForm";
import SettingsNewFormQuestions from "./pages/Settings/Forms/SettingsNewFormQuestions";
import SettingsFormView from "./pages/Settings/Forms/SettingsFormView";
import { SettingsFormFrame } from "./pages/Settings/Forms/SettingsFormFrame";
import { Box } from "./components/Box";
import SettingsApplicationTypeNewForms from "./pages/Settings/SettingsApplicationTypeNewForms";
import Login2FA from "./pages/Login2FA";
import RecoverAccount from "./pages/2FactorAuthentication/RecoverAccount";
import RecoveryCode from "./pages/2FactorAuthentication/RecoveryCode";
import RecoveryEmail from "./pages/2FactorAuthentication/RecoveryEmail";
import RecoveryEmailOTP from "./pages/2FactorAuthentication/RecoveryEmailOTP";
import LoginSetup2FA from "./pages/Login_Setup_2FA";
import { ChecksActivateMonitoring } from "./pages/ChecksActivateMonitorings";
import { ChecksActivateMonitoringIndividual } from "./pages/ChecksActivateMonitoringIndividual";
import { ApplicationsActivateMonitoringIndividual } from "./pages/ApplicationsActivateMonitoringIndividual";
import { ApplicationsActivateMonitoring } from "./pages/ApplicationsActivateMonitoring";
import { AddMonitoring } from "./pages/ChecksIndividuals/AddMonitoring";
import SettingsIncomeAndEmployment from "./pages/Settings/SettingsIncome&Employment";
import { NewCompanyCheck } from "./pages/ChecksIndividuals/NewCompanyCheck";
import { AddCompanyDetails } from "./pages/ChecksIndividuals/AddCompanyDetails";
import { AddCompanyAddress } from "./pages/ChecksIndividuals/AddCompanyAddress";
import { RunCompanyChecks } from "./pages/ChecksIndividuals/RunCompanyChecks";
import { CompanyChecksView } from "./pages/CompanyChecksView";
import { DirtyFormProvider } from "./DirtyFormContext";
import { useRef } from "react";
import SettingsConsultants from "./pages/Settings/SettingsConsultants";
import SettingsDivisionsTeams from "./pages/Settings/SettingsDivisionsTeams";
import SettingsRolesPermissions from "./pages/Settings/SettingsRolesPermissions";
import Download from "./pages/DeepLinkFallback";
import { SessionManager } from "./pages/SessionManager";
import { NewComapnyMonitoring } from "./pages/NewMonitoringRecord/NewComapnyMonitoring";
import { NewCompanyMonitoringSummary } from "./pages/NewMonitoringRecord/NewCompanyMonitoringSummary";
import MonitoringRouteGuard from "./pages/MonitoringRouteGuard";
import SettingsPropertiesAddressTypes from "./pages/Settings/Properties/SettingsPropertiesAddressTypes";
import SettingsPropertiesIndustries from "./pages/Settings/Properties/SettingsPropertiesIndustries";
import SettingsPropertiesSectors from "./pages/Settings/Properties/SettingsPropertiesSectors";
import SettingsPropertiesCountry from "./pages/Settings/Properties/SettingsPropertiesCountry";
import SettingsPropertiesProfileRelationshipTypes from "./pages/Settings/Properties/SettingsPropertiesProfileRelationshipTypes";
import SettingsPropertiesEntityTypes from "./pages/Settings/Properties/SettingsPropertiesEntityTypes";
import SettingsSummaryView from "./pages/Settings/Forms/SettingsSummaryView";
import Profiles from "./pages/Profiles";
import { NewEntityProfile } from "./pages/Profiles/Entity/NewEntityProfile";
import { NewPersonProfile } from "./pages/Profiles/Person/NewPersonProfile";
import AddEntityAddress from "./pages/Profiles/Entity/AddEntityAddress";
import NewEntitySummary from "./pages/Profiles/Entity/NewEntitySummary";
import AddPersonAddress from "./pages/Profiles/Person/AddPersonAddress";
import NewPersonSummary from "./pages/Profiles/Person/NewPersonSummary";
import { ProfileDetails } from "./pages/Profile/ProfileDetails";
import { ProfileTab } from "./pages/Profile/ProfileTab";
import { ProfileOrgTab } from "./pages/Profile/ProfileOrgTab";
import {
  EntityDetailsStep,
  ApplicationTypeStep,
  AddContactStep,
  SendInvitesStep,
} from "./pages/Profile/ProfileApplicationNew";
import { ApplicationFlowLayout } from "./pages/Profile/ProfileApplicationNew/ApplicationFlowLayout";
import SettingsAddressHistory from "./pages/Settings/SettingsAddressHistory";
import ApplicationsRouteGuard from "./pages/ApplicationsRouteGuard";
import ScreeningRouteGuard from "./pages/ScreeningRouteGuard";
import ProfilesRouteGuard from "./pages/ProfilesRouteGuard";
import {
  SelectChecksStep,
  AddPersonOrEntityStep,
  AddScreeningAddressStep,
  ScreeningReviewStep,
} from "./pages/Profile/ProfileScreeningNew";
import { ProfileMonitoringDetailsStep } from "./pages/Profile/ProfileMonitoringNew/ProfileMonitoringDetailsStep";
import { ProfileMonitoringSummaryStep } from "./pages/Profile/ProfileMonitoringNew/ProfileMonitoringSummaryStep";

const App = () => {
  const formRef = useRef(null);
  const isProduction =
    process.env.NODE_ENV === "production" ||
    process.env.NODE_ENV === "development" ||
    process.env.NODE_ENV === "test";

  return (
    <DirtyFormProvider formRef={formRef}>
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={isProduction}
        loadingComponent={
          <Flex justifyContent="center" alignItems="center" minHeight="100vh">
            <Loader />
          </Flex>
        }
      >
        <AppContent />
      </CacheBuster>
    </DirtyFormProvider>
  );
};

const AppContent = () => {
  return (
    <>
      <SessionManager />
      <Routes>
        <Route path="/" element={<Navigate to={ROUTE.LOGIN} />} />
        <Route path={ROUTE.LOGIN} element={<Login />} />
        <Route path={ROUTE.LOGIN_2FA} element={<Login2FA />} />
        <Route path={ROUTE.SETUP2FA} element={<LoginSetup2FA />} />
        <Route path={ROUTE.Download} element={<Download />} />

        <Route path={ROUTE.RECOVER_ACCOUNT} element={<RecoverAccount />} />
        <Route path={ROUTE.USE_RECOVERY_CODE} element={<RecoveryCode />} />
        <Route path={ROUTE.USE_RECOVERY_EMAIL} element={<RecoveryEmail />} />
        <Route path={ROUTE.EMAIL_OTP} element={<RecoveryEmailOTP />} />

        <Route path={ROUTE.LOGOUT} element={<Logout />} />
        <Route path={ROUTE.SIGN_UP} element={<SignUp />}>
          <Route path={ROUTE.VERIFY} element={<SignUp />} />
          <Route path={ROUTE.SETUP_2FA} element={<SignUp />} />
          <Route path={ROUTE.ADD_COMPANY} element={<SignUp />} />
          <Route path={ROUTE.ADD_COMPANY_ADDRESS} element={<SignUp />} />
          <Route path={ROUTE.ADD_BILLING_INFORMATION} element={<SignUp />} />
          <Route path={ROUTE.ADD_BILLING_ADDRESS} element={<SignUp />} />
          <Route path={ROUTE.ADD_PRIMARY_PURPOSE} element={<SignUp />} />
          <Route path={ROUTE.ADD_DPO} element={<SignUp />} />
        </Route>

        <Route path={ROUTE.CREATE_PASSWORD} element={<CreatePassword />} />
        <Route path={ROUTE.RESET_PASSWORD} element={<ResetPassword />} />
        <Route
          path={ROUTE.RESET_PASSWORD_CONFIRMATION}
          element={<ResetPasswordConfirmation />}
        />
        <Route path={ROUTE.ACCOUNT_PENDING} element={<AccountPending />} />

        <Route
          path={ROUTE.INDIVIDUAL}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <IndividualView />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />

        <Route
          path={ROUTE.APPLICATIONS}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <Applications />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.APPLICATION_NEW}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <NewApplication />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.ACTIVATE_APPLICATIONS_INDIVIDUAL_MONITORING}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <ApplicationsActivateMonitoringIndividual />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.ACTIVATE_APPLICATIONS_MONITORING}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <ApplicationsActivateMonitoring />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.APPLICATION}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <ApplicationView />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.APPLICATION_INDIVIDUALS}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <ApplicationIndividuals />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.APPLICATION_INDIVIDUALS_NEW}
          element={
            <AuthenticatedRoute>
              <ApplicationsRouteGuard>
                <AddApplicationIndividual />
              </ApplicationsRouteGuard>
            </AuthenticatedRoute>
          }
        />

        <Route
          path={ROUTE.CHECKS}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <Checks />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECKS_INDIVIDUAL}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <IndividualChecksView />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECKS_COMPANY}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <CompanyChecksView />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECKS_NEW}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <NewCheck />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECKS_NEW_COMPANY}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <NewCompanyCheck />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECK_INDIVIDUALS_NEW}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <AddCheckIndividual />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECK_COMPANY_NEW_DETAILS}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <AddCompanyDetails />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECK_ADDRESS_NEW}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <AddAddress />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECK_NEW_COMPANY_ADDRESS}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <AddCompanyAddress />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.ACTIVATE_CHECKS_MONITORING_INDIVIDUAL}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <ChecksActivateMonitoringIndividual />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.ACTIVATE_CHECKS_MONITORING}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <ChecksActivateMonitoring />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.RUN_CHECKS}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <RunChecks />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.RUN_COMPANY_CHECKS}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <RunCompanyChecks />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.CHECK_MONITORING}
          element={
            <AuthenticatedRoute>
              <ScreeningRouteGuard>
                <AddMonitoring />
              </ScreeningRouteGuard>
            </AuthenticatedRoute>
          }
        />

        <Route
          path={ROUTE.MONITORING}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <Monitoring />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.MONITORING_INDIVIDUAL}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <IndividualMonitoringView />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.MONITORING_NEW}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <NewIndividual />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.MONITORING_NEW_COMPANY}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <NewComapnyMonitoring />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.MONITORING_NEW_COMPANY_CONFIRM}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <NewCompanyMonitoringSummary />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.MONITORING_NEW_CONFIRM}
          element={
            <AuthenticatedRoute>
              <MonitoringRouteGuard>
                <NewMonitoring />
              </MonitoringRouteGuard>
            </AuthenticatedRoute>
          }
        />

        <Route
          path={ROUTE.PROFILES}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <Profiles />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_PERSON}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <NewPersonProfile />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_PERSON_ADDRESS}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <AddPersonAddress />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_PERSON_SUMMARY}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <NewPersonSummary />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_ENTITY}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <NewEntityProfile />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_ENTITY_ADDRESS}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <AddEntityAddress />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_NEW_ENTITY_SUMMARY}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <NewEntitySummary />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={ROUTE.PROFILE_DETAIL_VIEW}
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <ProfileDetails />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        >
          <Route index element={<ProfileTab />} />
          <Route path="org" element={<ProfileOrgTab />} />
        </Route>

        <Route
          path="/profile/:id/applications/new"
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <ApplicationFlowLayout />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        >
          <Route path="entity-details" element={<EntityDetailsStep />} />
          <Route path="application-type" element={<ApplicationTypeStep />} />
          <Route path="add-contact" element={<AddContactStep />} />
          <Route path="send-invites" element={<SendInvitesStep />} />
        </Route>

        <Route
          path="/profile/:id/screening/new"
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <ApplicationFlowLayout />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        >
          <Route path="select-checks" element={<SelectChecksStep />} />
          <Route path="add-person-entity" element={<AddPersonOrEntityStep />} />
          <Route path="add-address" element={<AddScreeningAddressStep />} />
          <Route path="review" element={<ScreeningReviewStep />} />
        </Route>

        <Route
          path="/profile/:id/monitoring/new"
          element={
            <AuthenticatedRoute>
              <ProfilesRouteGuard>
                <ApplicationFlowLayout />
              </ProfilesRouteGuard>
            </AuthenticatedRoute>
          }
        >
          <Route path="details" element={<ProfileMonitoringDetailsStep />} />
          <Route path="summary" element={<ProfileMonitoringSummaryStep />} />
        </Route>

        <Route
          path={ROUTE.SETTINGS}
          element={
            <AuthenticatedRoute>
              <Settings />
            </AuthenticatedRoute>
          }
        >
          <Route index element={<SettingsCompanyDetails />} />
          <Route
            path={ROUTE.SETTINGS_BRANDING}
            element={<SettingsSplashScreens />}
          />
          <Route
            path={ROUTE.SETTINGS_BRANDING_SPLASH_NEW}
            element={<SettingsBranding />}
          />
          <Route
            path={ROUTE.SETTINGS_BRANDING_SPLASH}
            element={<SettingsBranding />}
          />
          <Route
            path={ROUTE.SETTINGS_CONSULTANTS}
            element={<SettingsConsultants />}
          />
          <Route
            path={ROUTE.SETTINGS_DIVISIONS_TEAMS}
            element={<SettingsDivisionsTeams />}
          />
          <Route
            path={ROUTE.SETTINGS_ROLES_PERMISSIONS}
            element={<SettingsRolesPermissions />}
          />
          <Route
            path={ROUTE.SETTINGS_BILLING_DETAILS}
            element={<SettingsBillingDetails />}
          />
          <Route path={ROUTE.SETTINGS_USERS} element={<SettingsUsers />} />
          <Route path={ROUTE.SETTINGS_DPO_DETAILS} element={<SettingsDPO />} />

          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPE}
            element={<SettingsApplicationTypeView />}
          />
          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPE_NEW}
            element={<SettingsApplicationTypeNew />}
          />
          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPE_NEW_CHECKS}
            element={<SettingsApplicationTypeNewChecks />}
          />
          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPE_NEW_FORMS}
            element={<SettingsApplicationTypeNewForms />}
          />
          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPE_NEW_DOCUMENTS}
            element={<SettingsApplicationTypeNewDocuments />}
          />
          <Route
            path={ROUTE.SETTINGS_APPLICATION_TYPES}
            element={<SettingsApplicationTypes />}
          />
          <Route
            path={ROUTE.SETTINGS_SOF_RISK_SCORING}
            element={<SettingsSOFRiskScoring />}
          />
          <Route
            path={ROUTE.SETTINGS_ADDITIONAL_DOCUMENTS_REQUESTS}
            element={<SettingsAdditionalDocumentsRequests />}
          />
          <Route path={ROUTE.SETTINGS_FORMS} element={<SettingsForms />} />
          <Route path={ROUTE.SETTINGS_FORM_NEW} element={<SettingsNewForm />} />

          <Route
            path={ROUTE.SETTINGS_FORM_NEW_QUESTIONS}
            element={
              <SettingsFormFrame step="questions">
                <Box pl={4} pr={2} flex={4} minWidth={400}>
                  <SettingsNewFormQuestions />
                </Box>
              </SettingsFormFrame>
            }
          />

          <Route
            path={ROUTE.SETTINGS_FORM_SUMMARY}
            element={
              <SettingsFormFrame step="summary">
                <Box pl={4} pr={2} flex={4} minWidth={400}>
                  <SettingsSummaryView />
                </Box>
              </SettingsFormFrame>
            }
          />

          <Route
            path={ROUTE.SETTINGS_FORM_VIEW}
            element={<SettingsFormView />}
          />

          <Route
            path={ROUTE.SETTINGS_PEP_SANCTION_SCREENING}
            element={<SettingsPEPSanctions />}
          />
          <Route
            path={ROUTE.SETTINGS_INCOME_AND_EMPLOYMENT}
            element={<SettingsIncomeAndEmployment />}
          />
          <Route
            path={ROUTE.SETTINGS_ADDRESS_HISTORY}
            element={<SettingsAddressHistory />}
          />

          <Route
            path={ROUTE.SETTINGS_PROPERTY_ADDRESS_TYPES}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesAddressTypes />
              </ProfilesRouteGuard>
            }
          />
          <Route
            path={ROUTE.SETTINGS_PROPERTY_INDUSTRIES}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesIndustries />
              </ProfilesRouteGuard>
            }
          />
          <Route
            path={ROUTE.SETTINGS_PROPERTY_SECTORS}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesSectors />
              </ProfilesRouteGuard>
            }
          />
          <Route
            path={ROUTE.SETTINGS_PROPERTY_COUNTRY}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesCountry />
              </ProfilesRouteGuard>
            }
          />
          <Route
            path={ROUTE.SETTINGS_PROPERTY_ENTITY_TYPES}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesEntityTypes />
              </ProfilesRouteGuard>
            }
          />
          <Route
            path={ROUTE.SETTINGS_PROPERTY_RELATIONSHIP_TYPES}
            element={
              <ProfilesRouteGuard redirectTo={ROUTE.SETTINGS} billingOnly>
                <SettingsPropertiesProfileRelationshipTypes />
              </ProfilesRouteGuard>
            }
          />
        </Route>

        <Route
          path={ROUTE.PROFILE}
          element={
            <AuthenticatedRoute>
              <Profile />
            </AuthenticatedRoute>
          }
        />

        <Route
          path={ROUTE.HELP_AND_SUPPORT}
          element={
            <AuthenticatedRoute>
              <HelpSupport />
            </AuthenticatedRoute>
          }
        />

        {/* only match this when no other routes match */}
        <Route path={ROUTE.NOT_FOUND} element={<NotFound />} />
        <Route path={ROUTE.SERVER_ERROR} element={<ServiceUnavailablePage />} />
      </Routes>
    </>
  );
};

export default App;
